export default __webpack_public_path__ + "static/media/agency-img.a5da290e.jpg";